"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createLogonResponse = void 0;

var _lodash = require("lodash");

var _genericAsResultHeader = require("../../../../utils/generic-as-result-header");

var _modelBuilders = require("../../../../utils/model-builders");

var _BooleanAsNumber = require("../../../../types/BooleanAsNumber");

var _DataServerDate = require("../../../../types/DataServerDate");

/*
  Sample XML Response:
<?xml version="1.0" encoding="utf-8"?>
<soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
    <soap:Body>
        <LogonResponse xmlns="http://www.aperio.com/webservices/">
            <LogonResult>
                <ASResult>0</ASResult>
                <ASMessage></ASMessage>
                <ASDetails></ASDetails>
            </LogonResult>
            <Token>f64760be6bc05f078be9ada7d041da81117556032d0f51a3a2598f03fff54bac</Token>
            <TokenExpirationTime>2018-03-17T17:47:35.4777844-07:00</TokenExpirationTime>
            <UserData>
                <Id>3</Id>
                <LoginName>administrator</LoginName>
                <FullName>Administrator</FullName>
                <Password/>
                <AdminUser/>
                <LastLoginTime>2018-03-17 17:32:35</LastLoginTime>
                <ExpireTime/>
                <SuccessiveInvalidLogins>0</SuccessiveInvalidLogins>
                <OldPasswordList/>
                <LastPasswordChange/>
                <AccountCreateDate/>
                <Phone></Phone>
                <E_Mail></E_Mail>
                <AutoView>0</AutoView>
                <StartPage>(default)</StartPage>
                <ScanDataGroupId>1</ScanDataGroupId>
                <DisableLicenseWarning>0</DisableLicenseWarning>
                <Inactive>0</Inactive>
                <LastUsedRoleId>1</LastUsedRoleId>
                <ImageTransferNotificationEmail>0</ImageTransferNotificationEmail>
                <AcceptedTerms/>
                <Photo/>
                <ProfessionalTitle></ProfessionalTitle>
                <Institution></Institution>
                <Specialty></Specialty>
                <SubSpecialty></SubSpecialty>
                <Searchable/>
                <CreatedBy/>
                <ViewingMode>0</ViewingMode>
                <MedicalSchool></MedicalSchool>
                <Residency></Residency>
                <Certification></Certification>
                <ExternalId></ExternalId>
                <AuthType>Spectrum</AuthType>
                <ExternalLoginName></ExternalLoginName>
                <LockOnInvalidPass/>
                <LockIfUnused/>
                <AllowSingleLogin/>
                <UserMustChangePassword>False</UserMustChangePassword>
                <PasswordCanExpire/>
                <DscAvailability>1</DscAvailability>
                <DisableWorkflowEmailNotification>0</DisableWorkflowEmailNotification>
                <DisableAutoSlideFlip>0</DisableAutoSlideFlip>
                <StartApp></StartApp>
                <DefaultRoleId/>
                <DisplayHoverPopups>1</DisplayHoverPopups>
                <InstitutionId/>
                <IsLocked/>
                <PublicDisplayName></PublicDisplayName>
                <Biography></Biography>
                <UserId>3</UserId>
                <IsSystemUser>True</IsSystemUser>
                <IsGuest>False</IsGuest>
                <IsExpired>False</IsExpired>
                <ExpireDate></ExpireDate>
                <LastLogin>2018-03-17 17:32</LastLogin>
                <PasswordDaysLeft>-1</PasswordDaysLeft>
                <Privileges>
                    <AdminUser>True</AdminUser>
                </Privileges>
                <AccountStatus>
                    <LockOnInvalidPass>False</LockOnInvalidPass>
                    <LockIfUnused>False</LockIfUnused>
                    <UserMustChangePassword>False</UserMustChangePassword>
                    <PasswordCanExpire>False</PasswordCanExpire>
                </AccountStatus>
            </UserData>
        </LogonResponse>
    </soap:Body>
</soap:Envelope>
*/
var createLogonResponse = function createLogonResponse(raw) {
  var result = (0, _modelBuilders.parseKey)(raw, {
    path: 'LogonResult[0]',
    model: _genericAsResultHeader.genericAsResultHeader
  });
  var token = (0, _modelBuilders.parseKey)(raw, {
    path: 'Token[0]',
    type: String
  });
  var expires = (0, _modelBuilders.parseKey)(raw, {
    path: 'TokenExpirationTime[0]',
    type: _DataServerDate.DataServerDate
  });
  var user = (0, _modelBuilders.parseKey)(raw, {
    path: 'UserData[0]',
    model: userModel
  });
  return {
    result: result,
    response: {
      token: token,
      expires: expires,
      user: user
    }
  };
};

exports.createLogonResponse = createLogonResponse;
var userModel = {
  id: {
    type: Number,
    path: 'Id[0]'
  },
  loginName: {
    type: String,
    path: 'LoginName[0]'
  },
  fullName: {
    type: String,
    path: 'FullName[0]'
  },
  password: {
    type: String,
    path: 'Password[0]'
  },
  adminUser: {
    type: String,
    path: 'AdminUser[0]'
  },
  lastLoginTime: {
    type: _DataServerDate.DataServerDate,
    path: 'LastLoginTime[0]'
  },
  expireTime: {
    type: _DataServerDate.DataServerDate,
    path: 'ExpireTime[0]'
  },
  successiveInvalidLogins: {
    type: Number,
    path: 'SuccessiveInvalidLogins[0]'
  },
  lastPasswordChange: {
    type: _DataServerDate.DataServerDate,
    path: 'LastPasswordChange[0]'
  },
  accountCreateDate: {
    type: _DataServerDate.DataServerDate,
    path: 'AccountCreateDate[0]'
  },
  phone: {
    type: String,
    path: 'Phone[0]'
  },
  email: {
    type: String,
    path: 'E_Mail[0]'
  },
  autoView: {
    type: _BooleanAsNumber.BooleanAsNumber,
    path: 'AutoView[0]'
  },
  scanDataGroupId: {
    type: Number,
    path: 'ScanDataGroupId[0]'
  },
  disableLicenseWarning: {
    type: _BooleanAsNumber.BooleanAsNumber,
    path: 'DisableLicenseWarning[0]'
  },
  inactive: {
    type: _BooleanAsNumber.BooleanAsNumber,
    path: 'Inactive[0]'
  },
  lastUsedRoleId: {
    type: Number,
    path: 'LastUsedRoleId[0]'
  },
  imageTransferNotificationEmail: {
    type: _BooleanAsNumber.BooleanAsNumber,
    path: 'ImageTransferNotificationEmail[0]'
  },
  acceptedTerms: {
    type: String,
    path: 'AcceptedTerms[0]'
  },
  photo: {
    type: String,
    path: 'Photo[0]'
  },
  professionalTitle: {
    type: String,
    path: 'ProfessionalTitle[0]'
  },
  institution: {
    type: String,
    path: 'Institution[0]'
  },
  specialty: {
    type: String,
    path: 'Specialty[0]'
  },
  subSpecialty: {
    type: String,
    path: 'SubSpecialty[0]'
  },
  searchable: {
    type: String,
    path: 'Searchable[0]'
  },
  createdBy: {
    type: String,
    path: 'CreatedBy[0]'
  },
  viewingMode: {
    type: Number,
    path: 'ViewingMode[0]'
  },
  medicalSchool: {
    type: String,
    path: 'MedicalSchool[0]'
  },
  residency: {
    type: String,
    path: 'Residency[0]'
  },
  certification: {
    type: String,
    path: 'Certification[0]'
  },
  externalId: {
    type: String,
    path: 'ExternalId[0]'
  },
  authType: {
    type: String,
    path: 'AuthType[0]'
  },
  externalLoginName: {
    type: String,
    path: 'ExternalLoginName[0]'
  },
  lockOnInvalidPass: {
    type: String,
    path: 'LockOnInvalidPass[0]'
  },
  lockIfUnused: {
    type: String,
    path: 'LockIfUnused[0]'
  },
  allowSingleLogin: {
    type: String,
    path: 'AllowSingleLogin[0]'
  },
  userMustChangePassword: {
    type: Boolean,
    path: 'UserMustChangePassword[0]'
  },
  passwordCanExpire: {
    type: _BooleanAsNumber.BooleanAsNumber,
    path: 'PasswordCanExpire[0]'
  },
  dscAvailability: {
    type: _BooleanAsNumber.BooleanAsNumber,
    path: 'DscAvailability[0]'
  },
  disableWorkflowEmailNotification: {
    type: _BooleanAsNumber.BooleanAsNumber,
    path: 'DisableWorkflowEmailNotification[0]'
  },
  disableAutoSlideFlip: {
    type: _BooleanAsNumber.BooleanAsNumber,
    path: 'DisableAutoSlideFlip[0]'
  },
  startApp: {
    type: String,
    path: 'StartApp[0]'
  },
  defaultRoleId: {
    type: Number,
    path: 'DefaultRoleId[0]'
  },
  displayHoverPopups: {
    type: _BooleanAsNumber.BooleanAsNumber,
    path: 'DisplayHoverPopups[0]'
  },
  institutionId: {
    type: Number,
    path: 'InstitutionId[0]'
  },
  isLocked: {
    type: Boolean,
    path: 'IsLocked[0]'
  },
  publicDisplayName: {
    type: String,
    path: 'PublicDisplayName[0]'
  },
  biography: {
    type: String,
    path: 'Biography[0]'
  },
  userId: {
    type: String,
    path: 'UserId[0]'
  },
  isSystemUser: {
    type: Boolean,
    path: 'IsSystemUser[0]'
  },
  isGuest: {
    type: Boolean,
    path: 'IsGuest[0]'
  },
  isExpired: {
    type: Boolean,
    path: 'IsExpired[0]'
  },
  expireDate: {
    type: _DataServerDate.DataServerDate,
    path: 'ExpireDate[0]'
  },
  lastLogin: {
    type: _DataServerDate.DataServerDate,
    path: 'LastLogin[0]'
  },
  passwordDaysLeft: {
    type: Number,
    path: 'PasswordDaysLeft[0]'
  },
  privileges: function privileges(raw) {
    return Object.keys((0, _lodash.get)(raw, 'Privileges[0]'));
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/security/authentication/response-parsers/login-response.js
// module id = 214
// module chunks = 0